////////
// SideMenu
////////
var SideMenu = function(element) {

	this.selectors = {
    sidemenu: ".side-menu",
		inner: ".side-menu-inner",
		link: ".side-menu-link",
		start: ".page-content .block:first-of-type",
		endPreFooter: ".block-pre-footer",
		endFooter: ".footer",
		collisionTargets: ".btn-page[role='previous']"
	};

	this.flags = {
		CONTRAST_DARK: "dark",
		CONTRAST_LIGHT: "light",
		MINI: "mini",
		MUTE: "mute",
		ACTIVE: "active"
	}

  // Get key DOM elements
  this.element = $(element);
	this.width = this.element.width();
  this.inner = this.element.find(this.selectors.inner);
	this.getCollisionTargets();

  // Render links
  this.links = [];
  var obj = this;
  $.each(this.element.find(this.selectors.link), function(i, el) {

		// Create link
    var link = new SideMenuLink(el);
    obj.links.push(link);

		// Check contrast immediately
		link.checkBackgroundContrast();

		// Then monitor
    link.startMonitor();
  });

	// Check width
	this.modifyToPageWidth();

	// Start monitors
	this.startCollisionMonitor();
	this.startResizeMonitor();

	// Show menu
	this.element.removeClass(this.flags.MUTE);
}

/***
* Start resize monitor
***/
SideMenu.prototype.startResizeMonitor = function() {
  var ticking = false;
  var obj = this;

  window.addEventListener('resize', function(e) {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        obj.modifyToPageWidth();
        ticking = false;
      });
      ticking = true;
    }
  });
}


/***
* Check for resize
***/
SideMenu.prototype.modifyToPageWidth = function() {
	if(window.innerWidth - this.width < 1350) {
		this.element.addClass(this.flags.MINI);
	} else {
		this.element.removeClass(this.flags.MINI);
	}
}

/***
* Gather collision targets from DOM
***/
SideMenu.prototype.getCollisionTargets = function() {
	this.collisionTargets = $(this.selectors.collisionTargets);
}

/***
* Start the collision monitor
***/
SideMenu.prototype.startCollisionMonitor = function() {
  var ticking = false;
	var count = 0;
  var obj = this;

  window.addEventListener('scroll', function(e) {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        obj.checkForCollisions();
				if(++count == 50) {
					// Re-appraise DOM for new targets
					obj.getCollisionTargets();
				}
        ticking = false;
      });
      ticking = true;
    }
  });
}


/***
* Checks for collisions
***/
SideMenu.prototype.checkForCollisions = function() {

	var obj = this;
	var aHeight = this.element.height();
  var position = this.element.offset();
	var y = position.top - window.scrollY;

  // Loop through objects at that location
	var mute = false;

	$.each(this.collisionTargets, function(i, el) {
		var target = $(el);

		// Get positions of both elements based on document size
		var aRect = {
			top: obj.element.offset().top,
			height: aHeight
		};
		var bRect = {
			top: target.offset().top,
			height: target.height()
		};
		var padd = 25;

    if(!(
        ((aRect.top + aRect.height + padd) < (bRect.top)) ||
        (aRect.top > (bRect.top + bRect.height + padd))
    )) {
			mute = true;
		}
	});

	// Decide on effect
	if(mute) {
		this.element.addClass(this.flags.MUTE);
	} else {
		this.element.removeClass(this.flags.MUTE);
	}
}
